export enum FormSubmissionStatus {
    PENDING = 'Pending',
    COMPLETED = 'Completed',
  }